import { useContext } from "react";

import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import WarningIcon from "../../assets/images/warning-icon.svg";
import { DBAvailableContext } from "../../contexts/DBAvailableProvider";
import Heading from "../Heading/Heading";

import style from "./UnderMaintenance.module.css";

const UnderMaintenance = () => {
  const { dbDownMessage } = useContext(DBAvailableContext);

  return (
    <div className={style.underMaintenanceWrapper}>
      <div className={classNames(style.underMaintenance)}>
        <img className={style.wrenchIcon} src={WarningIcon} />
        <Heading type="h1">The site is under maintenance.</Heading>
        <span className={style.subHeader}>{dbDownMessage}</span>

        <Button className={style.button} onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </div>
  );
};

export default UnderMaintenance;
